// app/assets/javascripts/react/ducks/forms.js
import { actionize, apiFetch, apiAction } from 'utils';
import DuckEntity from './DuckEntity';

class FormDuckEntity extends DuckEntity {
  constructor(name) {
    super(name);

    // Override get to handle opts.form_type
    this.actions.get = (id, opts) => {
      return apiAction(
        this.types.GET_BEGIN,
        this.types.GET_SUCCESS,
        this.types.GET_ERROR,
        (state) => apiFetch.get(state, `${baseEntity.config.apiPath}/${id}?form_type=${opts.form_type}`),
        { id },
        { form: this.schema }
      );
    };
  }
}

const baseEntity = new FormDuckEntity('forms');

let types = {
  UPDATE_PAYMENT_METHOD_BEGIN: null,
  UPDATE_PAYMENT_METHOD_SUCCESS: null,
  UPDATE_PAYMENT_METHOD_ERROR: null
};
types = actionize(types, (action) => `schooladmin/forms/${action}`);

const updatePaymentMethod = (entity) => {
  return apiAction(
    types.UPDATE_PAYMENT_METHOD_BEGIN,
    types.UPDATE_PAYMENT_METHOD_SUCCESS,
    types.UPDATE_PAYMENT_METHOD_ERROR,
    (state) => apiFetch.post(
      state,
      `${baseEntity.config.apiPath}/${entity.id}/update_payment`,
      {
        form: {
          payment_method: entity.payment_method,
          payment_profile_id: entity.payment_profile_id
        },
        form_type: entity.form_type
      }
    ),
    {entity: entity, entityName: baseEntity.name, create: false, update: true},
    {form: baseEntity.schema}
  );
};

export const entity = {
  ...baseEntity,
  actions: {
    ...baseEntity.actions,
    updatePaymentMethod
  }
};

export default baseEntity.reducer;
